<template>
  <header>
    <login-logic :user="user" v-model:user="user"></login-logic>
  </header>
  <div
      data-dev="v2"
      class="vw-100 vh-100 d-flex flex-column flex-md-row m-0 p-0"
  >
    <main class="flex-grow-1 order-md-2 p-2 p-md-4 overflow-y-auto">
      <flash-messages
          v-if="getConfig('is_flash_message')"
      />


      <DashboardUniversalModule
        :module-data="dashboard"
      />

<!--
      <display-debug>
        <template #debugView>
          dashboard {{dashboard}}
        </template>
      </display-debug>
      -->
    </main>

    <nav class="order-md-1">
      <main-menu :user="user"></main-menu>
    </nav>
  </div>
</template>

<script>
import loginLogic from "@/components/logic/Login";
import flashMessage from "@/components/general/FlashMessage";
import mainMenu from "@/components/general/MainMenu";
import axios from "axios";
import general from "@/components/config/general";
import DashboardBoxShortcut from "@/dashboards/DashboardBoxShortcut"
import DashboardBoxList from "@/dashboards/DashboardBoxList"
import DashboardBoxText from "@/dashboards/DashboardBoxText"
import flashMessages from "@/components/general/FlashMessages";
import offlineDetect from "@/components/general/OfflineDetect";
import dashboard from "@/components/general/Dashboard";
import DisplayDebug from "@/components/general/DisplayDebug.vue";
import DashboardUniversalModule from "@/modules/DashboardUniversalModule.vue";

export default {
  name: 'DashboardView',
  components: {
    DisplayDebug,
    loginLogic,
    flashMessage,
    mainMenu,
    DashboardBoxShortcut,
    DashboardBoxList,
    DashboardBoxText,
    flashMessages,
    offlineDetect,
    dashboard,
    DashboardUniversalModule,
  },
  data() {
    return {
      dashboard: {
        data: null,
        dashboard_title: null
      },
      status:{
        is_loading: false,
        is_err: false,
        err: null,
      },
      reloadSignal: null,
      listFilters: null,
      moduleObj: {},
      user: {},
      err: {},
      contentLoadingStatus: false,
      routes: {},
      returnData: {},
      filterValues: {},
    }
  },
  _data() {

    return {
      dashboard_data: [],
      user: {
        testval: "ttteeeex"
      },
    }
  },
  methods: {
    async loadMainDashboards(){
      axios.defaults.baseURL = this.getBaseRoot();
      await axios({
        url: this.getApiConfig('general.dashboards.path'),
        method: this.getApiConfig('general.dashboards.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        if(res.data.response.dashboard_title) {
          this.dashboard.dashboard_title = res.data.response.dashboard_title;
        }
        if(res.data.response.data) {
          this.dashboard.data = res.data.response.data;
        }

      }).catch((err) => {
        this.err = "Dashboar nenalezen, kontaktujte spravce"
      })
    },
  },
  created() {
    this.setDocumentTitle('Dashboard');
    this.loadMainDashboards();
  },
}
</script>